// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_Cx","title":"e_Dx","container":"e_Ex","list":"e_Fx"};